module Widgets.Form.Simple where

import Common

import Concur.React.DOM as D
import Concur.React.Props as P
import Error (renderErrorDetails)
import Widgets.Form.Class (class FormWidget, noGetData, noSetData, fieldClass, fieldId)

newtype Label = Label
    { id :: String
    , label :: String
    , cls :: String
    }
derive newtype instance showLabel :: Show Label

instance labelFW :: FormWidget Label where
    getId (Label state) = state.id
    isLeaf _ = true
    asField _ = Nothing
    fieldPaths _ _ = []

    toWidget fc (Label state) = D.p
        [ P.dangerouslySetInnerHTML {__html: state.label}
        , P.className $ fieldClass state
        , P.key $ fieldId fc state.id
        , P._id $ fieldId fc state.id
        ] []

    getData = noGetData
    setData = noSetData


newtype FormError = FormError { id :: String, err :: ErrorWrapper }
derive newtype instance showFormError :: Show FormError

instance formErrFW :: FormWidget FormError where
    getId (FormError state) = state.id
    isLeaf _ = true
    asField _ = Nothing
    fieldPaths _ _ = []

    toWidget fc (FormError state) = D.div [P.className "widget-error", P.key $ fieldId fc state.id]
        [ D.h4' [D.text errText]
        , renderErrorDetails state.err
        ]
      where
        errText = "An error occurred while handling widget with ID " <> fieldId fc state.id

    getData = noGetData
    setData = noSetData
